<template>
    <paper class="trialBillingExceptionHandle">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :searchTotalTitle="config.searchTotalTitle"
            :pickerConfig="config.pickerConfig"
            :loading="loading"
            searchId="trialBillingExceptionHandleQuery"
            pageID="trialBillingExceptionHandle"
            :currentPage="page.pageNo"
            @btnClick="btnClick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
        >
        <div slot="page-module-btn">
            <el-button
                type="primary"
                :loading="handleRecalculateLoading"
                v-has="''"
                @click="handleRecalculate"
                >批量试算</el-button
            >
            <el-button
                type="primary"
                v-has="''"
                @click="handleBatchDelete"
                >批量删除</el-button
            >
        </div>
        </m-pane>
    </paper>
</template>

<script>
import mPane from '@/components/otpPanel';
import paper from '@/components/core/paper/Paper';
import config from './config.js';
import { queryByPage, handleRecalculate, batchDelete } from '@otp/api/trialBillingExceptionHandle.js';
import { validateSearchData, formatSearchData, formatTotalDataList, messageTips, urlToBcpSupplierDetail, urlToBcpConnectionDetail } from './util.js';
export default {
    name: 'trialBillingExceptionHandle',
    components: {
        mPane,
        paper
    },
    data () {
        return {
            config,
            loading: false,
            pageTotal: 0,
            selected: [], // 选中数据
            totalData: [], // 列表数据
            page: { pageSize: 10, pageNo: 1 }, // 分页数据
            dictData: {}, // 数据字典集合
            handleRecalculateLoading: false, // 重算按钮加载动画
            handleDeleteLoading: false, // 删除按钮加载动画
            searchParams: {}
        };
    },
    methods: {
        /**
         * @description 选择数据变化触发事件
         * @param {Object} data 选中表格数据
         */
        selectChange (data) {
            this.selected = data;
        },

        /**
         * @description 查询条件变化触发事件
         * @param {Object} data 查询条件
         */
        searchChange (data) {
            this.page.pageNo = 1;
            this.searchParams = data;
            this.getList(data);
        },

        /**
         * @getList 获取列表接口
         * @param {Object} this.page 查询条件
         */
        async getList (data) {
            // 格式化查询条件
            const _searchData = formatSearchData(data || this.getSearchBoxData());
            // 查询条件校验
            const isQueryOk = validateSearchData(_searchData);
            // 执行操作
            if (!isQueryOk) return;
            this.page = {
                ...this.page,
                ..._searchData
            };
            queryByPage(this.page).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = formatTotalDataList(res.data.list || []);
                    this.pageTotal = res.data.totalCount || 0;
                }
            }).catch(() => {});
        },
        // 从查询组件里面获取查询参数
        getSearchBoxData () {
            const params = {
                ...this.searchParams,
                ...this.$refs.tablePage.$refs.searchList.onSearchChange(null, true)
            };
            return params;
        },
        // 校验是否选中数据
        handleMinLimit () {
            if (!this.selected.length) {
                this.$message.warning('至少选择一条数据');
                return false;
            }
            return true;
        },
        /**
         * @description 批量操作，调用后端接口（前端无需校验）
         * @param {fn} 接口
         * @param {params} 接口参数
         * @param {loadingType} 按钮加载动画开关
         */
        handleBatchAction (fn, params, loadingType) {
            const isOk = this.handleMinLimit(this.selected);
            if (!isOk) return;
            this[loadingType] = true;
            fn(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(`${res.data}`);
                }
            }).finally(() => {
                this[loadingType] = false;
                this.getList();
            });
        },
        // 批量-试算
        handleRecalculate () {
            const params = this.selected.map(v => v.taskNo);
            this.handleBatchAction(handleRecalculate, params, 'handleRecalculateLoading');
        },
        // 批量删除
        handleBatchDelete () {
            const isOk = this.handleMinLimit(this.selected);
            if (!isOk) return;
            const params = this.selected.map(v => v.id);
            messageTips('此操作将删除选中数据，请确认是否删除?', batchDelete, params, '操作成功', this);
        },
        /**
         * @description 表格内按钮触发, 点击费用代码跳转中台计费页面
         * @param {val} 当前值
         * @param {index} 当前索引
         * @param {rowData} 当前操作行数据
         */
        btnClick (val, index, rowData, prop) {
            if (prop === 'rateCode') {
                // 收付标识rpFlag=R 跳转至中台客户费率详情页，rpFlag=P 跳转至中台供应商费率详情页
                switch (rowData.rpFlag) {
                case 'P':
                    window.open(urlToBcpSupplierDetail(rowData.rateCode));
                    break;
                case 'R':
                    window.open(urlToBcpConnectionDetail(rowData.rateCode));
                    break;
                default:
                };
            } else if (prop === 'taskNo') {
                this.$router.push({
                    query: { taskNo: rowData.taskNo },
                    path: '/distribute/transport-details'
                });
            }
        },

        // 页数改变
        sizeChange (pageSize) {
            this.page.pageNo = 1;
            this.page.pageSize = pageSize;
            this.getList();
        },

        // 切分页
        pageChange (pageNo) {
            this.page.pageNo = pageNo;
            this.getList();
        }
    }
};
</script>

<style lang="less">
.trialBillingExceptionHandle {
    #mPane3{
    .otp-table{
       .el-table{
            min-height: calc(100vh - 200px) ;
            max-height: calc(100vh - 200px) ;
        }
    }
  }
}
</style>
